module.exports = __webpack_public_path__ + "static/media/mb2.edb32b88.png";